import SchemeServicingManager from '@/scheme-servicing-manager'

export default {

    data() {
        return {
            /**
             * @type {?Scheme}
             */
            servicingScheme: null,

            loaded: false,
        }
    },

    computed: {

        /**
         * @returns {Scheme}
         */
        scheme() {
            return this.$scheme
        },

        /**
         * @returns {string}
         */
        serviceName() {
            return this.scheme.policyData.app.name
        },
    },

    async mounted() {
        this.servicingScheme = await SchemeServicingManager.getDefaultServicedSchemeAsync()
        this.loaded = true
    },
}
